export const adminCustomerColumns = [
  { field: "name", label: "Name" },
  { field: "email", label: "Email" },
  { field: "phone", label: "Phone Number" },
  { field: "gender", label: "Gender" },
  { field: "order_status", label: "Status" },
  { field: "action", label: "Action" },
];
